const EVENT_NAME = 'event'
const CATEGORY = {
    FOOTER: 'Footer',
    HEADER: 'Header',
    HOME: 'Home',
    SEARCH_RESULTS: 'Search Results',
    LEAGUE_LANDING_PAGE: 'League Landing Page',
    PERFORMER_LANDING_PAGE: 'Performer Landing Page',
    CITY_LANDING_PAGE: 'City Landing Page',
    VENUE_LANDING_PAGE: 'Venue Landing Page',
    TICKET_LISTING: 'Ticket Listing',
    ZONE_LISTING: 'Zone Listing',
    LANDING_PAGE: 'Landing Page',
    CHECKOUT_BILLING: 'Checkout Billing',
    CAMPAIGN_LANDING_PAGE: 'Campaign Landing Page'
}

const ACTION = {
    BULLETIN: 'Bulletin',
    CLICK: 'Click',
    FILTER: 'Filter',
    FORM: 'Form',
    LISTING: 'Listing',
    MAP: 'Map',
    MODAL: 'Modal',
    NAVIGATION: 'Navigation',
    SEARCH: 'Search',
    LOYALTY: 'Loyalty',
    MODAL_OPEN: 'Modal Open'
}

const HEADER = {
    PARTNER_LOGO_SELECTED: {
        eventCategory: CATEGORY.HEADER,
        eventAction: ACTION.NAVIGATION,
        eventLabel: 'logo'
    },
    NAVIGATION_PERFORMER_SELECTED: {
        eventCategory: CATEGORY.HEADER,
        eventAction: ACTION.NAVIGATION,
        eventLabel: 'taxonomy',
        value: null
    },
    NAVIGATION_TAXONOMY_SELECTED: {
        eventCategory: CATEGORY.HEADER,
        eventAction: ACTION.NAVIGATION,
        eventLabel: 'taxonomy',
        value: 'dead-click'
    },
    LOGIN_SELECTED: {
        eventCategory: CATEGORY.HEADER,
        eventAction: ACTION.NAVIGATION,
        eventLabel: 'sign-in'
    },
    SEARCH_QUERY_SEARCHED: {
        eventCategory: CATEGORY.HEADER,
        eventAction: ACTION.SEARCH,
        eventLabel: 'query'
    },
    SEARCH_SUGGESTION_SELECTED: {
        eventCategory: CATEGORY.HEADER,
        eventAction: ACTION.SEARCH,
        eventLabel: 'suggestion',
        value: null
    },
    SEARCH_PILL_SELECTED: {
        eventCategory: CATEGORY.HEADER,
        eventAction: ACTION.SEARCH,
        eventLabel: 'recent-tag',
        value: 'select'
    },
    SEARCH_PILL_DISMISSED: {
        eventCategory: CATEGORY.HEADER,
        eventAction: ACTION.SEARCH,
        eventLabel: 'recent-tag',
        value: 'dismiss'
    },
    BULLETIN_SELECTED: {
        eventCategory: CATEGORY.HEADER,
        eventAction: ACTION.BULLETIN,
        eventLabel: 'more-info'
    },
    MOBILE_NAVIGATION_TAXONOMY_SELECTED: {
        eventCategory: CATEGORY.HEADER,
        eventAction: ACTION.CLICK,
        eventLabel: 'mweb-search',
        value: null
    }
}
const FOOTER = {
    HELP_CLICKED: {
        eventCategory: CATEGORY.FOOTER,
        eventAction: ACTION.CLICK,
        eventLabel: 'help'
    },
    LEGAL_CLICKED: {
        eventCategory: CATEGORY.FOOTER,
        eventAction: ACTION.CLICK,
        eventLabel: 'legal'
    },
    PRIVACY_CLICKED: {
        eventCategory: CATEGORY.FOOTER,
        eventAction: ACTION.CLICK,
        eventLabel: 'privacy'
    }
}
const HOME = {
    LOCATION_FILTER_CHANGED: {
        eventCategory: CATEGORY.HOME,
        eventAction: ACTION.FILTER,
        eventLabel: 'location'
    },
    DATE_FILTER_SET: {
        eventCategory: CATEGORY.HOME,
        eventAction: ACTION.FILTER,
        eventLabel: 'date'
    },
    FILTER_BAR_TAXONOMY_SELECTED: {
        eventCategory: CATEGORY.HOME,
        eventAction: ACTION.FILTER,
        eventLabel: 'taxonomy',
        value: null,
    },
    IMAGE_TILE_SELECTED: {
        eventCategory: CATEGORY.HOME,
        eventAction: ACTION.LISTING,
        eventLabel: 'event-tile',
        value: null
    },
    EVENT_LIST_EVENT_SELECTED: {
        eventCategory: CATEGORY.HOME,
        eventAction: ACTION.LISTING,
        eventLabel: 'event'
    },
    SEE_MORE_BUTTON_SELECTED: {
        eventCategory: CATEGORY.HOME,
        eventAction: ACTION.LISTING,
        eventLabel: 'see-more'
    },
    RECENTLY_VIEWED_EVENT_TILE_SELECTED: {
        eventCategory: CATEGORY.HOME,
        eventAction: ACTION.LISTING,
        eventLabel: 'recently-viewed'
    }
}
const LEAGUE_LANDING_PAGE = {
    LOCATION_FILTER_CHANGED: {
        eventCategory: CATEGORY.LEAGUE_LANDING_PAGE,
        eventAction: ACTION.FILTER,
        eventLabel: 'location'
    },
    DATE_RANGE_FILTER_APPLIED: {
        eventCategory: CATEGORY.LEAGUE_LANDING_PAGE,
        eventAction: ACTION.FILTER,
        eventLabel: 'date'
    },
    PEFORMER_NAME_SELECTED: {
        eventCategory: CATEGORY.LEAGUE_LANDING_PAGE,
        eventAction: ACTION.LISTING,
        eventLabel: 'performer',
        value: null
    },
    EVENT_SELECTED: {
        eventCategory: CATEGORY.LEAGUE_LANDING_PAGE,
        eventAction: ACTION.LISTING,
        eventLabel: 'event'
    },
    LOAD_MORE_EVENTS_SELECTED: {
        eventCategory: CATEGORY.LEAGUE_LANDING_PAGE,
        eventAction: ACTION.LISTING,
        eventLabel: 'see-more'
    }
}
const PERFORMER_LANDING_PAGE = {
    LOCATION_FILTER_HOME_APPLIED: {
        eventCategory: CATEGORY.PERFORMER_LANDING_PAGE,
        eventAction: ACTION.FILTER,
        eventLabel: 'game-location',
        value: 'home'
    },
    LOCATION_FILTER_AWAY_APPLIED: {
        eventCategory: CATEGORY.PERFORMER_LANDING_PAGE,
        eventAction: ACTION.FILTER,
        eventLabel: 'game-location',
        value: 'away'
    },
    LOCATION_FILTER_ALL_APPLIED: {
        eventCategory: CATEGORY.PERFORMER_LANDING_PAGE,
        eventAction: ACTION.FILTER,
        eventLabel: 'game-location',
        value: 'all'
    },
    OPPONENT_SELECTED_APPLIED: {
        eventCategory: CATEGORY.PERFORMER_LANDING_PAGE,
        eventAction: ACTION.FILTER,
        eventLabel: 'opponent'
    },
    DATE_RANGE_FILTER_APPLIED: {
        eventCategory: CATEGORY.PERFORMER_LANDING_PAGE,
        eventAction: ACTION.FILTER,
        eventLabel: 'date'
    },
    EVENT_SELECTED: {
        eventCategory: CATEGORY.PERFORMER_LANDING_PAGE,
        eventAction: ACTION.LISTING,
        eventLabel: 'event'
    },
    LOAD_MORE_EVENTS_SELECTED: {
        eventCategory: CATEGORY.PERFORMER_LANDING_PAGE,
        eventAction: ACTION.LISTING,
        eventLabel: 'see-more'
    },
    LOCATION_FILTER_CHANGED: {
        eventCategory: CATEGORY.PERFORMER_LANDING_PAGE,
        eventAction: ACTION.FILTER,
        eventLabel: 'location'
    }
}
const CITY_LANDING_PAGE = {
    EVENT_TAXONOMY_FILTER_CLICKED: {
        eventCategory: CATEGORY.CITY_LANDING_PAGE,
        eventAction: ACTION.FILTER,
        eventLabel: 'taxonomy',
        value: null
    },
    DATE_RANGE_FILTER_APPLIED: {
        eventCategory: CATEGORY.CITY_LANDING_PAGE,
        eventAction: ACTION.FILTER,
        eventLabel: 'date'
    },
    EVENT_SELECTED: {
        eventCategory: CATEGORY.CITY_LANDING_PAGE,
        eventAction: ACTION.LISTING,
        eventLabel: 'event'
    },
    LOAD_MORE_EVENTS_SELECTED: {
        eventCategory: CATEGORY.CITY_LANDING_PAGE,
        eventAction: ACTION.LISTING,
        eventLabel: 'see-more'
    }
}
const VENUE_LANDING_PAGE = {
    EVENT_TAXONOMY_FILTER_CLICKED: {
        eventCategory: CATEGORY.VENUE_LANDING_PAGE,
        eventAction: ACTION.FILTER,
        eventLabel: 'taxonomy',
        value: null
    },
    DATE_RANGE_FILTER_APPLIED: {
        eventCategory: CATEGORY.VENUE_LANDING_PAGE,
        eventAction: ACTION.FILTER,
        eventLabel: 'date'
    },
    EVENT_SELECTED: {
        eventCategory: CATEGORY.VENUE_LANDING_PAGE,
        eventAction: ACTION.LISTING,
        eventLabel: 'event'
    },
    LOAD_MORE_EVENTS_SELECTED: {
        eventCategory: CATEGORY.VENUE_LANDING_PAGE,
        eventAction: ACTION.LISTING,
        eventLabel: 'see-more'
    }
}
const TICKET_LISTING = {
    LOYALTY_EARN_TOGGLE_SELECTED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.LOYALTY,
        eventLabel: 'earn'
    },
    LOYALTY_REDEEM_TOGGLE_SELECTED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.LOYALTY,
        eventLabel: 'redeem'
    },
    QUANTITY_FILTER_APPLIED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.FILTER,
        eventLabel: 'quantity'
    },
    MIN_PRICE_FILTER_TEXT_INPUTTED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.FILTER,
        eventLabel: 'price',
        value: 'min box'
    },
    MAX_PRICE_FILTER_TEXT_INPUTTED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.FILTER,
        eventLabel: 'price',
        value: 'max box'
    },
    MIN_PRICE_FILTER_SLIDER_NODE_APPLIED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.FILTER,
        eventLabel: 'price',
        value: 'min-slider'
    },
    MAX_PRICE_FILTER_SLIDER_NODE_APPLIED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.FILTER,
        eventLabel: 'price',
        value: 'max-slider'
    },
    ELECTRONIC_ONLY_FILTER_APPLIED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.FILTER,
        eventLabel: 'electronic-tickets'
    },
    TICKET_LISTING_CLICKED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'ticket'
    },
    NON_STRIKETHROUGH_TICKET_LISTING_CLICKED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'ticket',
        value: 'no discount'
    },
    STRIKETHROUGH_TICKET_LISTING_CLICKED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'ticket',
        value: 'discount'
    },
    TICKET_LISTING_PINNED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'pin',
        value: 'ticket'
    },
    PRE_CHECKOUT_LISTING_PINNED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'pin',
        value: 'seatview'
    },
    SEAT_VIEW_EXPANDED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'seatview',
        value: 'expand'
    },
    SEAT_VIEW_COLLAPSED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'seatview',
        value: 'collapse'
    },
    PRE_CHECKOUT_BACK_TO_TICKET_LISTINGS: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'more-seats'
    },
    PURCHASE: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.FORM,
        eventLabel: 'buy now'
    },
    PURCHASE_QUANTITY_SELECTED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.FORM,
        eventLabel: 'quantity'
    },
    MAP_SECTION_SELECTED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.MAP,
        eventLabel: 'section'
    },
    MAP_ROW_SELECTED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.MAP,
        eventLabel: 'row'
    },
    ZOOM_BUTTON_CLICKED: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.MAP,
        eventLabel: 'zoom',
        value: 'button'
    },
    GESTURE_ZOOM: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.MAP,
        eventLabel: 'zoom',
        value: 'gesture'
    },
    MAP_RESET: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.MAP,
        eventLabel: 'reset'
    },
    QUANTITY_MODAL: {
        1: {
            eventCategory: CATEGORY.TICKET_LISTING,
            eventAction: ACTION.MODAL,
            eventLabel: 'quantity',
            value: '1'
        },
        2: {
            eventCategory: CATEGORY.TICKET_LISTING,
            eventAction: ACTION.MODAL,
            eventLabel: 'quantity',
            value: '2'
        },
        3: {
            eventCategory: CATEGORY.TICKET_LISTING,
            eventAction: ACTION.MODAL,
            eventLabel: 'quantity',
            value: '3'
        },
        4: {
            eventCategory: CATEGORY.TICKET_LISTING,
            eventAction: ACTION.MODAL,
            eventLabel: 'quantity',
            value: '4'
        },
        5: {
            eventCategory: CATEGORY.TICKET_LISTING,
            eventAction: ACTION.MODAL,
            eventLabel: 'quantity',
            value: '5'
        },
        6: {
            eventCategory: CATEGORY.TICKET_LISTING,
            eventAction: ACTION.MODAL,
            eventLabel: 'quantity',
            value: '6'
        },
        7: {
            eventCategory: CATEGORY.TICKET_LISTING,
            eventAction: ACTION.MODAL,
            eventLabel: 'quantity',
            value: '7+'
        }
    },
    QUANTITY_MODAL_CLOSED_BY_BUTTON: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.MODAL,
        eventLabel: 'quantity',
        value: 'close'
    },
    QUANTITY_MODAL_CLOSED_BY_OUTSIDE_CLICK: {
        eventCategory: CATEGORY.TICKET_LISTING,
        eventAction: ACTION.MODAL,
        eventLabel: 'quantity',
        value: 'overlay'
    }
}
const ZONE_LISTING = {
    SELECT_A_GAME_HEADER_CLICKED: {
        eventCategory: CATEGORY.ZONE_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'event',
        value: 'expand'
    },
    EVENT_SELECTED: {
        eventCategory: CATEGORY.ZONE_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'event',
        value: 'select'
    },
    EVENT_PRELOADED: {
        eventCategory: CATEGORY.ZONE_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'event',
        value: 'preset'
    },
    NUMBER_OF_TICKETS_HEADER_CLICKED: {
        eventCategory: CATEGORY.ZONE_LISTING,
        eventAction: ACTION.FILTER,
        eventLabel: 'quantity',
        value: 'expand'
    },
    QUANTITY_SELECTED: {
        eventCategory: CATEGORY.ZONE_LISTING,
        eventAction: ACTION.FILTER,
        eventLabel: 'quantity',
        value: 'select'
    },
    SELECT_SEATING_HEADER_CLICKED: {
        eventCategory: CATEGORY.ZONE_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'ticket',
        value: 'expand'
    },
    NON_STRIKETHROUGH_TICKET_LISTING_CLICKED: {
        eventCategory: CATEGORY.ZONE_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'ticket',
        value: 'no discount'
    },
    STRIKETHROUGH_TICKET_LISTING_CLICKED: {
        eventCategory: CATEGORY.ZONE_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'ticket',
        value: 'discount'
    },
    PURCHASE: {
        eventCategory: CATEGORY.ZONE_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'buy now'
    },
    CLEAR_ALL_SELECTIONS_CLICKED: {
        eventCategory: CATEGORY.ZONE_LISTING,
        eventAction: ACTION.LISTING,
        eventLabel: 'clear all'
    }
}
const LANDING_PAGE = {
    QUEBEC_SERVICE_MODAL_IP_BLOCK: {
        eventCategory: CATEGORY.LANDING_PAGE,
        eventAction: ACTION.MODAL_OPEN,
        eventLabel: 'QC Block'
    },
    QUEBEC_SERVICE_MODAL_CHECKOUT_BLOCK: {
        eventCategory: CATEGORY.CHECKOUT_BILLING,
        eventAction: ACTION.MODAL_OPEN,
        eventLabel: 'QC Block'
    }
}

const CAMPAIGN_LANDING_PAGE = {
    PERFORMER_TILE_SELECTED: {
        eventCategory: CATEGORY.CAMPAIGN_LANDING_PAGE,
        eventAction: ACTION.LISTING,
        eventLabel: 'performer-tile',
        value: null
    },
    SEE_MORE_BUTTON_SELECTED: {
        eventCategory: CATEGORY.CAMPAIGN_LANDING_PAGE,
        eventAction: ACTION.LISTING,
        eventLabel: 'see-more',
        value: null
    }
}

export {
    EVENT_NAME,
    FOOTER,
    HEADER,
    HOME,
    LEAGUE_LANDING_PAGE,
    PERFORMER_LANDING_PAGE,
    CITY_LANDING_PAGE,
    VENUE_LANDING_PAGE,
    TICKET_LISTING,
    ZONE_LISTING,
    LANDING_PAGE,
    CAMPAIGN_LANDING_PAGE
}
